<template>
  <el-form-item class="confirm_numbers_comp" prop="confirm" :required="true">
    <template v-for="(n, i) in confirm.numberLength" :key="i">
      <el-input
        type="tel"
        pattern="\d*"
        :ref="(el) => (inputs[i] = el)"
        v-model="confirm.inputsValue[i]"
        :class="confirm.inputsValue[i] ? 'entered' : ''"
        autocomplete="off"
        @input="onInput($event, i)"
      ></el-input>
    </template>
  </el-form-item>
</template>

<script>
import { inject, ref } from "vue";

export default {
  components: {},
  setup() {
    const checkFormValidation = inject("checkFormValidation");
    // const setFormValidation = inject("setFormValidation");
    const formsRefs = inject("formsRefs");
    const confirm = inject("confirm");
    const goNext = inject("goNext");
    const lastSavedIndex = ref(null); // Variable to store the last saved index

    const inputs = [];

    const getCode = () => {
      return confirm.inputsValue.join("");
    };
    const getNextInput = (index) => {
      if (index >= inputs.length) return undefined;
      return inputs[index + 1];
    };
    const handlePaste = (value, index) => {
      if (value.length >= inputs.length) index = 0;

      value.split("").map((char, charIndex) => {
        console.log(char, index + charIndex);
        const inputIndex = index + charIndex;
        if (inputIndex < inputs.length) confirm.inputsValue[inputIndex] = char;
      });
    };
    const onInput = (value, index) => {
      const isFilled = value.length > 0;
      if (!isFilled) return;

      if (value.length > 1) {
        handlePaste(value, index);
      } else {
        const nextInput = getNextInput(index);
        if (nextInput) nextInput.focus();
      }

      const code = getCode();
  
      const isAllFilled = code.length == 5;
      if (isAllFilled) {
        confirm.value = code;
        formsRefs.authForm.value.clearValidate("confirm");
        checkFormValidation("authForm", true, "confirm");
         // Save the input at index 4 and check if the last saved index is the same as the current value
         if (index === 4) {
          // check if input is two digit or 1 digit if 2 digit take only first digit
          value = value.length > 1 ? value[0] : value;
          if (lastSavedIndex.value === value) {
            return;
          }
          lastSavedIndex.value = value;
        }
        goNext("authForm");
      }
    };
    return {
      confirm,
      inputs,
      checkFormValidation,
      formsRefs,
      goNext,
      getCode,
      getNextInput,
      handlePaste,
      onInput,
    };
  },
};
</script>
